import { render, staticRenderFns } from "./block-product-images.vue?vue&type=template&id=4041609d"
import script from "./block-product-images.vue?vue&type=script&lang=js"
export * from "./block-product-images.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports